export const CLIENT_PROJECT_STATUSES = {
    ACTIVE: 'Active',
    PAST: 'Past',
}
